import { useSelector } from "react-redux";
import findUnits from "../utils/findUnits";
import { isEmpty, listFromCsv } from "../utils/helpers";
import useQuery from "./useQuery";
import { Role } from "../utils/types";

const useUnit = entity => {
  const authState = useSelector(state => state.jazasoft.auth);
  const roles = authState?.roleList?.map(e => e.role?.roleId).filter(roleId => !isEmpty(roleId)) || [];

  const { data: unitData = [] } = useQuery({ url: "units", params: { size: 1000 } });
  const unitList = findUnits(unitData, authState?.units, entity?.unitIds, roles);
  const unitChoices = unitList.map(u => ({ id: u.unitId, name: u.name }));
  const userUnitIds = roles.includes(Role.MASTER) || roles.includes(Role.SUPER_USER) ? unitList.map(u => u.unitId) : listFromCsv(authState?.units);

  return { allUnitList: unitData, unitList, unitChoices, userUnitIds };
};

export default useUnit;
